<div class="business-hours-preview">
    <ng-template #businessHourPreviewTemplate>
      <span class="fa fa-close close-icon" tabindex="0" (click)="popover.hide()"></span>
      <h3 class="header">{{'checkout.Store Hours' | translate | translateKey }}</h3>
      <div class="row no-margin" *ngFor="let day of businessHours">
        <div class="col-xs-4 day">
          {{'checkout.' + day.day | translate | translateKey }}
        </div>
        <div class="col-xs-8 hours">
          <ng-container *ngIf="day.available && day.hours && day.hours.length && day.hours[0].start; else holidayTemplate">
            <div *ngFor="let hour of day.hours;let isFirst=first;let isLast=last;">
              <div *ngIf="!isFirst">and</div>
              <span> {{hour.start}}</span>
              <span *ngIf="hour.start && hour.end">-</span>
              <span> {{hour.end}}</span>
            </div>
          </ng-container>
          <ng-template #holidayTemplate>
            <span class="closed">{{'checkout.CLOSED' | translate | translateKey }}</span>
          </ng-template>
        </div>
      </div>
    </ng-template>
    <a class="link--light" #popover="bs-popover" containerClass="business-hours-preview--popover" container="body" [outsideClick]="true" [popover]="businessHourPreviewTemplate" href="javascript:void(0)">
      {{'checkout.Store Hours' | translate | translateKey }}
    </a>
  </div>
  


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/business-hour-preview.component.html